<soft-field-ok name="objekt"
               [title]="title()"
               [subtitle]="subtitle()"
               [placeholder]="placeholder()"
               [value]="$value()"
               [parameters]="{idktostamm_kunde: idktostamm_kunde()}"
               [readonly]="readonly()"
               (valueChange)="setValue($event)"></soft-field-ok>
